export const codes = [{
    name:'Access Bank', code:'044',
},{
    name:'Afribank', code:'014',
},{
    name:'Citi Bank', code:'023',
},{
    name:'Diamond Bank', code:'063',
},{
    name:'Ecobank', code:'050',
},{
    name:'Equitorial Trust Bank', code:'040',
},{
    name:'First Bank', code:'011',
},{
    name:'FCMB', code:'214',
},{
    name:'Fidelity Bank', code:'070',
},{
    name:'Finbank', code:'085',
},{
    name:'Guaranty Trust Bank', code:'058',
},{
    name:'Oceanic Bank', code:'056',
},{
    name:'BankPhb', code:'082',
},{
    name:'Polaris Bank', code:'076',
},{
    name:'StanbicIBTC ', code:'221',
},{
    name:'Standard Chartered Bank', code:'068',
},{
    name:'United Bank for Africa', code:'033',
},{
    name:'Union Bank', code:'032',
},{
    name:'Wema Bank', code:'035',
},{
    name:'Zenith Bank', code:'057',
},{
    name:'Unity Bank', code:'215',
}]